import { useEffect, useState } from "react";
import BigNumber from "bignumber.js";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";
import { formatUnits } from "ethers"; // Import formatUnits directly


export const useTotalSupply = (
  provider: ethers.ContractRunner | null | undefined
) => {
  const [data, setData] = useState("0");
  const tokenAddress = localStorage.getItem("tokenContractAddress");
  useEffect(() => {
    const getTotalSupply = async () => {
      const tokenContract = new ethers.Contract(
        tokenAddress || "",
        ERC20ABI.abi,
        provider
      );

      const res = await tokenContract.totalSupply();

      if (res) {
        console.log("Raw totalSupply:", res.toString());

        // Use the new formatUnits function from ethers v6
        const formattedSupply = formatUnits(res, 18);

        console.log("Formatted totalSupply:", formattedSupply);
        setData(formattedSupply);
      }
    };



    getTotalSupply().catch(console.error);

    const refreshInterval = setInterval(
      () => getTotalSupply().catch(console.error),
      3000
    );
    return () => clearInterval(refreshInterval);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
};
